import { moment } from '@hotjar/insights-common/lib/moment';
import type { MinimalDateConstraint } from '../DateRangeFilter/DateRangeFilterType';
import type { BasicListOption } from '../GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { ClickedOperation } from './ClickedFilterType';

export const OPTION_LIST: BasicListOption<ClickedOperation>[] = [
  { value: ClickedOperation.OCCURRED, label: 'occurred' },
  { value: ClickedOperation.DID_NOT_OCCUR, label: 'did not occur' },
];

const quantzMinDate = new Date('2022-07-05T00:00:00.000Z');
const nonBreakingSpace = '\u00A0';

export const START_DATE_OF_CLICKED_DATA_COLLECTION: MinimalDateConstraint = {
  minDate: quantzMinDate,
  isFilterRelated: true,
  reason: `Clicked element data is only available from ${moment(quantzMinDate)
    .format('MMMM D')
    .replace(' ', nonBreakingSpace)}.`,
  link: {
    text: 'Why is this?',
    href: '/articles/8917152574743#faq',
  },
};
